import Cookies from 'js-cookie';
import {isMultiLogin, getQuery} from '@/util';
import {LoginType} from '@/constants';

// 地图开平iframe嵌入，隐藏内容
// https://console.cloud.baidu-int.com/devops/icafe/issue/BE-EOP-14635/show
export function isLbsyun() {
    return !isMultiLogin() && getQuery('lbsyun') === '1';
}

// 云智学院只需要passport账号登录
// http://newicafe.baidu.com:80/issue/ACU-IPM-4240/show?from=page
export function isABCC() {
    return getQuery('fromService') === 'ABCC';
}

// https://cloud.baidu.com/summit/erniebot/index.html?track=90ae7b15c0a4eab
// 是否智能云文心一言发布会
export function isErniebot() {
    return getQuery('passport_phone') === 'true';
}

export function getLoginType() {
    if (isLbsyun()) {
        return LoginType.UC;
    }
    if (isABCC() || isErniebot()) {
        return LoginType.SMS_PASSPORT;
    }
    if (!isMultiLogin() || /\blogin_type=uc\b/.test(location.search)) {
        return LoginType.UC;
    }
    const defaultType = Cookies.get('default_ui_login_type');
    if (defaultType) {
        return defaultType;
    }
    return LoginType.SMS_PASSPORT;
}

// 从localStorage中获取上次登录方式
export function getLastLoginType() {
    return localStorage && localStorage.getItem('bce-last-login-type');
}
